import { InfoCircleFilled } from "@ant-design/icons";
import ToolTip from "../../../../shared/components/ToolTip/ToolTip";
import React, { useState } from 'react'
import "./EditSubAreaForm.css"

function EditSubAreaForm({ subArea, value, onChange }) {
  const [formData, setFormData] = useState({
    name: subArea?.name ?? "",
    code: subArea?.code ?? "",
    maxCapacity: subArea?.maxCapacity ?? null,
  });

  // Keep local state and notify parent on every change
  const update = (patch) => {
    const next = { ...formData, ...patch };
    setFormData(next);
    onChange?.(next);
  };

  const handleMaxCapacityInputChange = (e) => {
    const value = e.target.value;
    if (value === "" || (/^\d+$/.test(value) && value.length <= 4)) {
      update({ maxCapacity: value === "" ? null : Number(value) });
    }
  };

  // Sync form when a new subArea is selected
  React.useEffect(() => {
    setFormData({
      name: subArea?.name ?? "",
      code: subArea?.code ?? "",
      maxCapacity: subArea?.maxCapacity ?? null,
    });
    onChange?.({
      name: subArea?.name ?? "",
      code: subArea?.code ?? "",
      maxCapacity: subArea?.maxCapacity ?? null,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subArea?.code]); // using code as identity; adjust if needed

  return (
    <div className="sub-area-form">
      <div className="form-group">
        <label>Name</label>
        <input
          type="text"
          value={formData.name}
          onChange={(e) => update({ name: e.target.value })}
        />
      </div>
      <div className="form-group">
        <label>Code</label>
        <input
          type="text"
          value={formData.code}
          onChange={(e) => update({ code: e.target.value })}
        />
      </div>
      <div className="form-group">
        <label className="max-capacity-label">
          Max Capacity
          <span className="info-icon">
            <ToolTip placement="top" title="When unset or 0, capacity is unlimited.">
              <InfoCircleFilled />
            </ToolTip>
          </span>
        </label>
        <input
          type="text"
          value={formData.maxCapacity ?? ""}
          onChange={handleMaxCapacityInputChange}
          onKeyPress={(event) => {
            if (!/[0-9]/.test(event.key)) {
              event.preventDefault();
            }
          }}
          placeholder="Enter Capacity"
          maxLength={4}
        />
      </div>
    </div>
  );
}

export default EditSubAreaForm